var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { clearProps } from '../helpers';
export var ErrorBolderStatusIcon = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, clearProps(props), { width: "16", height: "16" }),
    React.createElement("path", { fill: "#e8595a", d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm4.55 10.72l-1.83 1.83L8 9.83l-2.72 2.72-1.83-1.83L6.17 8 3.45 5.28l1.83-1.83L8 6.17l2.72-2.72 1.83 1.83L9.83 8z" }))); };
//# sourceMappingURL=ErrorBolderStatusIcon.js.map